export default __webpack_public_path__ + "static/media/launch-dark.11281917.svg";